import { Box, Grid, IconButton, Skeleton, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { useHistory } from 'react-router-dom'
import { Colors } from '../../../Styles/Colors'
import DoughnutChart from '../../ChartDashboard/CommonCharts/DoughnutChart'
import Barchart from '../../ChartDashboard/CommonCharts/Barchart'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'
import { DateTime } from 'luxon'
import { StoreVendorPerformance } from '../../ChartDashboard/CommonCharts/TableColumns'

const tblData = [

]
const datelist = {
    fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    toDate: DateTime.fromJSDate(new Date()).toFormat('YYYY-MM-dd'),
    dateIndex: 1,
}
export default function StoreVendorPerChart() {
    const history = useHistory()
    const [isLoading, setisloading] = useState(true)
    const [filterData, setfilterData] = useState(datelist);

    const chartView = () => {
        return (
            <Box id="overallRef" sx={{width: '100%', height: '70vh', margin: '0.5vw auto', overflowY: 'scroll'}}>
                <Grid container spacing={1} >
                    <Grid item xs={4} >
                        <Box className="eMed_Individual_DashChart">
                            {isLoading ?
                                <Barchart
                                    title={"Vendor Performance"}
                                    Tlt2={"Count"}
                                    chartLabel={['one', 'two', 'three', 'four', 'five']}
                                    chartData={[250, 200, 125, 230, 440]}
                                    tblData={['one', 'two', 'three', 'four', 'five']}
                                    tblColumn={StoreVendorPerformance}
                                    hideTbl={true}
                                /> :
                                <Skeleton variant="rounded" width={"100%"} height={"100%"} animation="wave" />}
                        </Box>
                    </Grid>
                    <Grid item xs={4} >
                        <Box className="eMed_Individual_DashChart">
                            {isLoading ?
                                <Barchart
                                    title={"Vendor Average Period"}
                                    Tlt2={"Count"}
                                    chartLabel={['one', 'two', 'three', 'four', 'five']}
                                    chartData={[100, 200, 300, 400, 500]}
                                    tblData={['one', 'two', 'three', 'four', 'five']}
                                    tblColumn={StoreVendorPerformance}
                                    hideTbl={true}
                                /> :
                                <Skeleton variant="rounded" width={"100%"} height={"100%"} animation="wave" />}
                        </Box>
                    </Grid>
                    <Grid item xs={4} >
                        <Box className="eMed_Individual_DashChart">
                            {isLoading ?
                                <DoughnutChart
                                    title={"Vendor Free Quantity"}
                                    chartLabel={['vendor 1', 'vendor 2', 'vendor 3', 'vendor 4', 'vendor 5']}
                                    chartData={['12', '55', '66', '98', '87']}
                                    subTitle={'Free Quantity'}
                                    position={"bottom"}
                                    // extractValue={"revenue"}
                                    // extractLabel={"module"}
                                    tblData={['one', 'two', 'three', 'four', 'five']}
                                    tblColumn={StoreVendorPerformance}
                                    showValueAtCenter={true}
                                    hideTbl={true}
                                /> :
                                <Skeleton variant="rounded" width={"100%"} height={"100%"} animation="wave" />}
                        </Box>
                    </Grid>
                    <Grid item xs={4} >
                        <Box className="eMed_Individual_DashChart">
                            {isLoading ?
                                <DoughnutChart
                                    title={"Vendor Purchase Price"}
                                    chartLabel={['vendor 1', 'vendor 2', 'vendor 3', 'vendor 4', 'vendor 5']}
                                    chartData={['12', '55', '66', '98', '87']}
                                    subTitle={'Free Quantity'}
                                    position={"bottom"}
                                    tblData={['one', 'two', 'three', 'four', 'five']}
                                    tblColumn={StoreVendorPerformance}
                                    // extractValue={"revenue"}
                                    // extractLabel={"module"}
                                    showValueAtCenter={true}
                                    hideTbl={true}
                                /> :
                                <Skeleton variant="rounded" width={"100%"} height={"100%"} animation="wave" />}
                        </Box>
                    </Grid>
                    <Grid item xs={4} >
                        <Box className="eMed_Individual_DashChart">
                            {isLoading ?
                                <Barchart
                                    title={"Vendor Credit Note"}
                                    Tlt2={"Count"}
                                    chartLabel={['one', 'two', 'three', 'four', 'five']}
                                    chartData={[100, 200, 300, 400, 500]}
                                    tblData={['one', 'two', 'three', 'four', 'five']}
                                    tblColumn={StoreVendorPerformance}
                                    hideTbl={true}
                                /> :
                                <Skeleton variant="rounded" width={"100%"} height={"100%"} animation="wave" />}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
    }
    return (
        <Box>
            <Box component={'div'} className='eMed_Pharma_Header_Card'>
                <Stack direction="row" spacing={1} alignItems="center"><IconButton size="small" onClick={() => {
                    history.push({ pathname: '/StoreReports/VendorPerformance' })
                }} ><img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} /></IconButton><Typography sx={{ color: "#616161" }}> {"Back to Report"}</Typography></Stack>
            </Box>
            <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
                <Box  sx={{width: '14.2vw', position: 'relative', left: '80vw'}}>
                    <CommonDatePicker
                        FromDate={filterData.fromDate}
                        ToDate={filterData.toDate}
                        DateIndex={filterData.dateIndex}
                        SelectedDates={FilterDate.bind(this)}
                        HideAllMenu={true} />
                </Box>
                {chartView()}
            </Box>
        </Box>
    )
}
